import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Home";
import Leave from "./Leave";
import EditProfil from "./EditProfil";
import Settings from "./Settings";
import Analysis from "./Analysis";
import Login from "./Login";
import Register from "./Register";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import NavbarController from "./component/NavbarController";
import HomeAdmin from "./Admin/HomeAdmin";
import { Toaster } from "sonner";
import AnalysisAdmin from "./Admin/AnalysisAdmin";
import DataUser from "./Admin/DataUser";
import Logistics from "./Logistics";
import HistoryLogistics from "./HistoryLogistics";
import HistoryReportLogistics from "./HistoryReportLogistics";
import HistoryReport from "./HistoryReport";
import HistoryAnnouncement from "./HistoryAnnouncement";

const queryClient = new QueryClient();



const App = () => {
    
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="relative min-h-svh bg-slate-100 text-black">
          {/* NAVBAR */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leave" element={<Leave />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/analytics" element={<Analysis />} />
            <Route path="/edit-profile" element={<EditProfil />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<HomeAdmin />} />
            <Route path="/admin/analysis" element={<AnalysisAdmin />} />
            <Route path="/admin/data-user" element={<DataUser />} />
            <Route path="/logistics" element={<Logistics />} />
            <Route path="/logistics/history" element={<HistoryLogistics />} />
            <Route path="/logistics/report" element={<HistoryReportLogistics />} />
            <Route path="/history/announcement" element={<HistoryAnnouncement />} />
            <Route path="/history/report" element={<HistoryReport />} />
          </Routes>
          <NavbarController /> {/* Navbar dipindahkan ke komponen terpisah */}
          <Toaster position="top-center" richColors />
        </div>
      </Router>
    </QueryClientProvider>

  );
}

export default App;
